var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center pt-2"},[_vm._v("\n    Welcome To Domain Checkup system.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }